import { render, staticRenderFns } from "./asset-detail.vue?vue&type=template&id=49340ce0&"
import script from "./asset-detail.vue?vue&type=script&lang=js&"
export * from "./asset-detail.vue?vue&type=script&lang=js&"
import style0 from "./asset-detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports